import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-691404a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Usuários", -1))
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Para compartilhar o acesso à conta, convide o usuário por e-mail", -1))
const _hoisted_5 = { class: "header-action" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" CONVIDAR ")
const _hoisted_7 = { class: "form-body" }
const _hoisted_8 = { class: "row-cp" }
const _hoisted_9 = { class: "cp" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nome", -1))
const _hoisted_11 = { class: "cp" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Email", -1))
const _hoisted_13 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_14 = {
  key: 0,
  class: "actions"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editar", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode()
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Remover ")
const _hoisted_27 = {
  key: 1,
  class: "actions"
}
const _hoisted_28 = {
  class: "dialog",
  style: {"width":"66px"}
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode()
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode()
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1))
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createTextVNode()
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode()
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1))
const _hoisted_38 = {
  key: 2,
  class: "actions"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode()
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode()
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editar", -1))
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createTextVNode()
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Link ")
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/_createTextVNode()
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/_createTextVNode()
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/_createTextVNode()
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Remover ")
const _hoisted_56 = { key: 3 }
const _hoisted_57 = /*#__PURE__*/_createTextVNode()
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Remover ")
const _hoisted_60 = { class: "show-keys-partner" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "show-keys-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Link de Convite"),
  /*#__PURE__*/_createElementVNode("p", null, "Se um convidado não receber o link por e-mail, você pode fornecer manualmente o link de convite para que o usuário crie sua conta.")
], -1))
const _hoisted_62 = { class: "copy-url" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_UserSwitchOutlined = _resolveComponent("UserSwitchOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_LinkOutlined = _resolveComponent("LinkOutlined")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_input, {
            title: "email",
            value: _ctx.formValues.email,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValues.email) = $event)),
            placeholder: "E-mail",
            disabled: !_ctx.isActionAdminOrSysAdmin
          }, null, 8, ["value", "disabled"]),
          _createVNode(_component_a_button, {
            type: "primary",
            class: "btn-add-user",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addUser())),
            disabled: !_ctx.isActionAdminOrSysAdmin
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(_component_a_divider),
      _createElementVNode("section", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["row", {'verified': !account.verified}]),
            key: account.id
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_a_input, {
                  title: "nome",
                  value: account.name,
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_a_input, {
                  title: "email",
                  value: account.email,
                  "onUpdate:value": ($event: any) => ((account.email) = $event),
                  placeholder: "E-mail",
                  disabled: !account.isEditing
                }, null, 8, ["value", "onUpdate:value", "disabled"]),
                (_ctx.mailError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.mailError), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.isActionAdminOrSysAdmin && account.verified && !account.isEditing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_a_popconfirm, {
                    class: "dialog",
                    placement: "left",
                    title: "Deseja realmente editar o e-mail desse usuário?",
                    cancelText: "Cancelar",
                    okText: "Alterar",
                    onConfirm: ($event: any) => (_ctx.changeMailUser(account))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_EditOutlined),
                        _hoisted_15,
                        _hoisted_16,
                        _hoisted_17,
                        _hoisted_18
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]),
                  _createVNode(_component_a_popconfirm, {
                    class: "dialog",
                    placement: "left",
                    title: "Deseja realmente alterar o nível de acesso desse usuário?",
                    cancelText: "Cancelar",
                    okText: "Alterar",
                    onConfirm: ($event: any) => (_ctx.changeTypeUser(account.id))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_UserSwitchOutlined),
                        _hoisted_19,
                        _hoisted_20,
                        _hoisted_21,
                        (account.type === 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Regular"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23, "Admin"))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]),
                  _createVNode(_component_a_popconfirm, {
                    class: "dialog",
                    placement: "left",
                    title: "Essa ação não pode ser revertida. Deseja realmente remover este usuário?",
                    cancelText: "Cancelar",
                    okText: "Remover",
                    onConfirm: ($event: any) => (_ctx.removeUser(account.id))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_DeleteOutlined),
                        _hoisted_24,
                        _hoisted_25,
                        _hoisted_26
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : (account.isEditing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_a_popconfirm, {
                      class: "dialog",
                      placement: "left",
                      title: "Confirma alteração ?",
                      cancelText: "Cancelar",
                      okText: "Alterar",
                      onConfirm: ($event: any) => (_ctx.alterMailUser(account))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_CheckOutlined),
                          _hoisted_29,
                          _hoisted_30,
                          _hoisted_31,
                          _hoisted_32
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]),
                    _createElementVNode("span", {
                      class: "dialog",
                      style: {"width":"66px"},
                      onClick: ($event: any) => (_ctx.cancelEditMail(account))
                    }, [
                      _createVNode(_component_CloseOutlined),
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37
                    ], 8, _hoisted_33)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(_component_a_popconfirm, {
                      class: "dialog",
                      placement: "left",
                      title: "Deseja realmente editar o e-mail desse usuário?",
                      cancelText: "Cancelar",
                      okText: "Alterar",
                      onConfirm: ($event: any) => (_ctx.changeMailUser(account))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createVNode(_component_EditOutlined),
                          _hoisted_39,
                          _hoisted_40,
                          _hoisted_41,
                          _hoisted_42
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]),
                    (_ctx.isActionAdminOrSysAdmin && !account.verified)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "dialog",
                          style: {"width":"66px"},
                          onClick: ($event: any) => (_ctx.getLinkToUser(account.id))
                        }, [
                          _createVNode(_component_LinkOutlined),
                          _hoisted_44,
                          _hoisted_45,
                          _hoisted_46
                        ], 8, _hoisted_43))
                      : (_openBlock(), _createElementBlock("span", _hoisted_47, [
                          _createVNode(_component_UserSwitchOutlined),
                          _hoisted_48,
                          _hoisted_49,
                          _hoisted_50,
                          (account.type === 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Regular"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_52, "Admin"))
                        ])),
                    (_ctx.isActionAdminOrSysAdmin)
                      ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                          key: 2,
                          class: "dialog",
                          placement: "left",
                          title: "Essa ação não pode ser revertida. Deseja realmente remover este usuário?",
                          cancelText: "Cancelar",
                          okText: "Remover",
                          onConfirm: ($event: any) => (_ctx.removeUser(account.id))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createVNode(_component_DeleteOutlined),
                              _hoisted_53,
                              _hoisted_54,
                              _hoisted_55
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_56, [
                          _createVNode(_component_DeleteOutlined),
                          _hoisted_57,
                          _hoisted_58,
                          _hoisted_59
                        ]))
                  ]))
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isShowLinkUser,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShowLinkUser) = $event)),
      centered: "",
      footer: null,
      maskClosable: false,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("section", _hoisted_62, [
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.urlActive,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.urlActive) = $event)),
                  size: "large",
                  disabled: true,
                  class: "cp-url"
                }, null, 8, ["value"]),
                _createVNode(_component_a_tooltip, { title: "Copiar Link de Convite" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "large",
                      onClick: _ctx.copyLinkUrl
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CopyOutlined)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}